import { MEMBER_ROLE_LABELS, MEMBER_ROLE_OPTIONS } from '../futures/futuresOrderConstants';
import { formatOptionalId } from '../deposits/onlineDepositConstants';

export { MEMBER_ROLE_LABELS, MEMBER_ROLE_OPTIONS, formatOptionalId };

export const PAYMENT_CURRENCY_TYPE_LABELS = {
  CRYPTO: '數字貨幣',
  BANK: '銀行卡',
  FIAT: '電子錢包',
};

export function formatPaymentCurrencyType(value) {
  if (!value) {
    return '—';
  }
  const key = typeof value === 'string' ? value : value?.name || value?.code || String(value);
  return PAYMENT_CURRENCY_TYPE_LABELS[key] || key;
}

export function formatRoleId(roleId) {
  if (roleId == null || roleId === '') {
    return '—';
  }
  return MEMBER_ROLE_LABELS[Number(roleId)] || String(roleId);
}

export function buildWithdrawAddressPageParams(pageNo, filters, pageSize = 20) {
  const params = { pageNo, pageSize };
  if (filters.roleId) {
    params.roleId = filters.roleId;
  }
  if (filters.topInviterId?.trim()) {
    params.topInviterId = filters.topInviterId.trim();
  }
  if (filters.inviterId?.trim()) {
    params.inviterId = filters.inviterId.trim();
  }
  if (filters.memberId?.trim()) {
    params.memberId = filters.memberId.trim();
  }
  if (filters.channelType?.trim()) {
    params.channelType = filters.channelType.trim();
  }
  if (filters.currencyName?.trim()) {
    params.currencyName = filters.currencyName.trim();
  }
  if (filters.withdrawAddress?.trim()) {
    params.withdrawAddress = filters.withdrawAddress.trim();
  }
  return params;
}
